import React, { useCallback, useState } from 'react';
import { Collapse as AntCollapse } from 'antd';

const CustomCollapse = ({
  items = [],
  expandIconPosition = 'start',
  onChange,
  customClass
}) => {
  const [panelStates, setPanelStates] = useState(
    items.reduce((acc, item) => {
      acc[item.key] = false; 
      return acc;
    }, {})
  );
  const handleCollapseChange = useCallback((keys) => {
    const updatedPanelStates = { ...panelStates };
  
    items.forEach(item => {
      updatedPanelStates[item.key] = keys.includes(item.key);
    });
  
    setPanelStates(updatedPanelStates);
  
    const changedPanels = items.filter(item => updatedPanelStates[item.key] !== panelStates[item.key]);
  
    if (onChange && changedPanels.length > 0) {
      onChange(changedPanels.map(item => ({
        id: item.key,
        state: updatedPanelStates[item.key]
      })));
    }
  }, [items, panelStates, onChange]);
  return (
    <AntCollapse
      onChange={handleCollapseChange}
      expandIconPosition={expandIconPosition}
      items={items}
      className={`${customClass} !border !border-StrokeColor bg-transparent`}
    />
  );
};

export default CustomCollapse;
